import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _dec, _obj;
import Controller from "@ember/controller";
import discourseComputed from "discourse-common/utils/decorators";
export default Controller.extend((_dec = discourseComputed("model.watchingCategories.[]", "model.watchingFirstPostCategories.[]", "model.trackingCategories.[]", "model.regularCategories.[]", "model.mutedCategories.[]"), (_obj = {
  selectedCategories(watching, watchingFirst, tracking, regular, muted) {
    return [].concat(watching, watchingFirst, tracking, regular, muted).filter(Boolean);
  }
}, (_applyDecoratedDescriptor(_obj, "selectedCategories", [_dec], Object.getOwnPropertyDescriptor(_obj, "selectedCategories"), _obj)), _obj)));